import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.views.QuoteDetailView.';
  public static readonly provideQuoteTitle = `${Id.prefix}provideQuoteTitle`;
  public static readonly validToDateFuture = `${Id.prefix}validToDateFuture`;
  public static readonly proposedDeliveryFuture = `${Id.prefix}proposedDeliveryFuture`;
  public static readonly quoteTitle = `${Id.prefix}quoteTitle`;
  public static readonly quoteNo = `${Id.prefix}quoteNo`;
  public static readonly quoteBudget = `${Id.prefix}quoteBudget`;
  public static readonly quoteDescription = `${Id.prefix}quoteDescription`;
  public static readonly internalOrderNo = `${Id.prefix}internalOrderNo`;
  public static readonly status = `${Id.prefix}status`;
  public static readonly type = `${Id.prefix}type`;
  public static readonly created = `${Id.prefix}created`;
  public static readonly lastModified = `${Id.prefix}lastModified`;
  public static readonly installationDate = `${Id.prefix}installationDate`;
  public static readonly quoteTypeNone = `${Id.prefix}quoteTypeNone`;
  public static readonly quoteTypeEstimate = `${Id.prefix}quoteTypeEstimate`;
  public static readonly quoteTypeQuote = `${Id.prefix}quoteTypeQuote`;
  public static readonly quoteTypeDisplay = `${Id.prefix}quoteTypeDisplay`;
  public static readonly quoteTypeWarranty = `${Id.prefix}quoteTypeWarranty`;
}

export class LangQuoteDetailView {
  private constructor() {}
  public static provideQuoteTitle(): string {
    return interpolate(Id.provideQuoteTitle);
  }
  public static validToDateFuture(): string {
    return interpolate(Id.validToDateFuture);
  }
  public static proposedDeliveryFuture(): string {
    return interpolate(Id.proposedDeliveryFuture);
  }
  public static quoteTitle(): string {
    return interpolate(Id.quoteTitle);
  }
  public static quoteNo(): string {
    return interpolate(Id.quoteNo);
  }
  public static quoteBudget(): string {
    return interpolate(Id.quoteBudget);
  }
  public static quoteDescription(): string {
    return interpolate(Id.quoteDescription);
  }
  public static internalOrderNo(): string {
    return interpolate(Id.internalOrderNo);
  }
  public static status(): string {
    return interpolate(Id.status);
  }
  public static type(): string {
    return interpolate(Id.type);
  }
  public static created(): string {
    return interpolate(Id.created);
  }
  public static lastModified(): string {
    return interpolate(Id.lastModified);
  }
  public static installationDate(): string {
    return interpolate(Id.installationDate);
  }
  public static readonly quoteType = {
    none: () => interpolate(Id.quoteTypeNone),
    estimate: () => interpolate(Id.quoteTypeEstimate),
    quote: () => interpolate(Id.quoteTypeQuote),
    display: () => interpolate(Id.quoteTypeDisplay),
    warranty: () => interpolate(Id.quoteTypeWarranty)
  };
}

export class QuoteDetailViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.provideQuoteTitle,
      "Please provide a {{glossary 'quote'}} Title",
      'Validation for missing quote title'
    );
    register.add(
      Id.validToDateFuture,
      "'Valid to' Date must be a date in the future not in the past.",
      'Validation for valid to date'
    );
    register.add(
      Id.proposedDeliveryFuture,
      "'Proposed Delivery' must be a date in the future not in the past.",
      'Validation for installation date'
    );
    register.add(Id.quoteTitle, "{{glossary 'quote'}} Title", 'Label for quote title');
    register.add(Id.quoteNo, "{{glossary 'quote'}} No", 'Label for quote number');
    register.add(Id.quoteBudget, "{{glossary 'quote'}} Budget", 'Label for quote budget');
    register.add(Id.quoteDescription, "{{glossary 'quote'}} Description", 'Label for quote description');
    register.add(Id.internalOrderNo, 'Internal Order No.', 'Label for internal order number');
    register.add(Id.status, 'Status', 'Label for status');
    register.add(Id.type, 'Type', 'Label for type');
    register.add(Id.created, 'Created', 'Label for created date');
    register.add(Id.lastModified, 'Last Modified', 'Label for last modified date');
    register.add(Id.installationDate, 'Installation Date', 'Label for installation date');
    register.add(Id.quoteTypeNone, 'None', 'Quote type: None');
    register.add(Id.quoteTypeEstimate, 'Estimate', 'Quote type: Estimate');
    register.add(Id.quoteTypeQuote, 'Quote', 'Quote type: Quote');
    register.add(Id.quoteTypeDisplay, 'Display', 'Quote type: Display');
    register.add(Id.quoteTypeWarranty, 'Warranty', 'Quote type: Warranty');
  }
}
